import React, { createContext, useContext, useState, useCallback, ReactNode, useEffect } from "react";
import { TRIPTYPE, upliftErrorMessage, paymentlabel, UPLIFTTRIPTYPE } from '../../utils/constant';

interface UpliftResponse {
  status: string;
  offer?: unknown;
  reason?: string[];
  token?: unknown;
}

interface UpliftContextType {
  cardInfo: unknown;
  disable: boolean;
  tokenReady: boolean;
  reasonCode: string | null;
  paymentOption: string;
  setPaymentOption: (option: string) => void;
  upliftCallback: (response: UpliftResponse) => void;
}

// Create Context
const UpliftContext = createContext<UpliftContextType | undefined>(undefined);

// Provider Component
export const UpliftProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [cardInfo, setCardInfo] = useState<unknown>(null);
  const [disable, setDisable] = useState<boolean>(false);
  const [tokenReady, setTokenReady] = useState<boolean>(false);
  const [reasonCode, setReasonCode] = useState<string | null>(null);
  const [paymentOption, setPaymentOption] = useState<string>(paymentlabel.FULLPAYMENT);

  const upliftCallback = useCallback((response: UpliftResponse) => {
    const { reasons, token } = JSON.parse(JSON.stringify(response));
    if(reasonCode ){
      return
    }
    const statusHandlers: Record<string, () => void> = {
      OFFER_AVAILABLE: () => {
        setDisable(false);
        setTokenReady(false);
      },
      TOKEN_AVAILABLE: () => {
        setDisable(false);
        setTokenReady(true);
      },
      TOKEN_RETRIEVED: () => {
        console.log("Token retrieved successfully",token);
        setCardInfo(token);
        setTokenReady(true);
      },
      OFFER_UNAVAILABLE: () => {
        setReasonCode(reasons ? reasons[0] : null);
        setDisable(true);
        if (paymentOption === "upliftpayment") {
          setPaymentOption("fullPayment");
          window.Uplift.Payments.deselect("fullPayment");
        }
      },
      SERVICE_UNAVAILABLE: () => {
        setDisable(true);
      },
    };


    const handler = statusHandlers[response.status];
    if (handler) {
      handler();
    } else {
      console.warn(`Unknown status: ${response.status}`);
    }
  }, [paymentOption]);

  return (
    <UpliftContext.Provider
      value={{
        cardInfo,
        disable,
        tokenReady,
        reasonCode,
        paymentOption,
        setPaymentOption,
        upliftCallback,
      }}
    >
      {children}
    </UpliftContext.Provider>
  );
};

// Custom Hook to use the Context
export const useUplift = (): UpliftContextType => {
  const context = useContext(UpliftContext);
  if (!context) {
    throw new Error("useUplift must be used within an UpliftProvider");
  }
  return context;
};
